import React from "react";
import { turkishCurrencyFormatterNoPrecision } from "../utils";

export default function CiroAndHarcamaTablo(props) {
  const { periodReport, netStockAmount } = props;
  return (
    <div>
      <table className="table table-bordered">
        <thead>
          <tr className="table-warning">
            <th></th>
            <th className="text-end">Ciro</th>
            <th className="text-end">Harcama</th>
            <th className="text-end">Net</th>
          </tr>
        </thead>
        <tbody>
          <tr className="table-warning">
            <td className="text-bold">POS</td>
            <td className="text-end">
              {turkishCurrencyFormatterNoPrecision(periodReport.totalPos)}
            </td>
            <td className="text-end">
              {turkishCurrencyFormatterNoPrecision(
                periodReport.totalExpensePos
              )}
            </td>
            <td className="text-end">
              {turkishCurrencyFormatterNoPrecision(
                periodReport.totalPos - periodReport.totalExpensePos
              )}
            </td>
          </tr>
          <tr className="table-warning">
            <td className="text-bold">Nakit</td>
            <td className="text-end">
              {turkishCurrencyFormatterNoPrecision(periodReport.totalCache)}
            </td>
            <td className="text-end">
              {turkishCurrencyFormatterNoPrecision(
                periodReport.totalExpenseCache
              )}
            </td>
            <td className="text-end ">
              {turkishCurrencyFormatterNoPrecision(
                periodReport.totalCache - periodReport.totalExpenseCache
              )}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr className="table-warning">
            <td className="text-bold">Toplam</td>
            <td className="text-end">
              {turkishCurrencyFormatterNoPrecision(
                periodReport.totalCache + periodReport.totalPos
              )}
            </td>
            <td className="text-end">
              {turkishCurrencyFormatterNoPrecision(
                periodReport.totalExpenseCache + periodReport.totalExpensePos
              )}
            </td>
            <td className="text-end">
              {turkishCurrencyFormatterNoPrecision(
                periodReport.totalCache +
                  periodReport.totalPos -
                  (periodReport.totalExpenseCache +
                    periodReport.totalExpensePos)
              )}

              {netStockAmount && (
                <span
                  className={
                    netStockAmount > 0
                      ? "small-text text-success"
                      : "small-text text-danger"
                  }
                >
                  {"/" + turkishCurrencyFormatterNoPrecision(netStockAmount)}
                </span>
              )}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
